import CollectionView from './base';
import Selectable from '../views/selectable';

export default CollectionView.extend( {
	modelView: Selectable,

	initialize: function() {
		CollectionView.prototype.initialize.apply( this, arguments );

		this.selected = null;

		this.on( 'child:select', child => {
			this.selected = child.model.id;
		} );

		this.on( 'child:unselect', child => {
			if ( this.selected === child.model.id ) {
				this.selected = null;
			}
		} );
	},

	select: function( id, options ) {
		var item;

		if ( this.selected ) {
			item = this.get( this.selected );
			if ( item ) {
				item.unselect( options );
			}
		}

		item = this.get( id );
		if ( item ) {
			item.select( options );
		}
	},
} );
